import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from './slice';

const selectDomain = (state: RootState) =>
  state.myautoiqNurturingJourneySettingsComponentState || initialState;

export const selectMyautoiqNurturingJourneySettings = createSelector(
  [selectDomain],
  state => state.myautoiqNurturingJourneySettings,
);
